
import React from 'react';
import { IMAGES, SOCIAL_LINKS } from '../constants';
import { CONTENT } from '../content';
import { useMetadata } from '../lib/seo';

const Home: React.FC = () => {
  useMetadata(CONTENT.home.metadataTitle, CONTENT.home.metadataDescription, CONTENT.metadata.keywords);

  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden bg-liza-bg">
      <div className="absolute inset-0 z-0">
        <img 
          src={IMAGES.hero} 
          alt={CONTENT.home.heroAlt} 
          className="w-full h-full object-cover"
          width="1920"
          height="1080"
          loading="eager"
        />
        <div className="absolute inset-0 bg-black/40"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10 py-32 text-center">
        <div className="max-w-4xl mx-auto text-center">
          {/* ST!R Gecertificeerd Badge */}
          <div className="flex flex-col items-center justify-center mb-8 relative group animate-fade-in">
            <a 
              href={SOCIAL_LINKS.stir} 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex flex-col items-center justify-center cursor-pointer select-none"
              title="Bekijk ST!R profiel van Liza Moerman (opent in nieuw tabblad)"
            >
              <div className="relative transition-transform duration-500 hover:scale-105 active:scale-95">
                <img 
                  src="/img/stir_erkend.png" 
                  alt="ST!R Gecertificeerd Coach" 
                  className="h-[80px] md:h-[100px] w-auto drop-shadow-[0_10px_20px_rgba(255,255,255,0.08)]"
                  width="100"
                  height="100"
                  loading="eager"
                  referrerPolicy="no-referrer"
                />
                <div className="absolute -inset-2 bg-white/5 rounded-full blur-xl opacity-0 group-hover:opacity-100 transition duration-500 -z-10 pointer-events-none"></div>
              </div>
              <span className="text-[10px] md:text-xs text-white/80 uppercase tracking-[0.3em] font-medium mt-3 drop-shadow-sm font-sans group-hover:text-white/100 transition-colors duration-300">
                ST!R Erkend Coach
              </span>
            </a>
          </div>

          <h1 className="text-5xl md:text-7xl text-white font-serif leading-tight mb-12 drop-shadow-lg">
            {CONTENT.home.title.line1} <br />
            <span className="italic font-normal text-white/90">{CONTENT.home.title.line2.split(' ')[0]}</span> {CONTENT.home.title.line2.split(' ').slice(1).join(' ')}
          </h1>
          <p className="text-xl md:text-2xl text-white/90 mb-16 leading-relaxed font-light max-w-2xl mx-auto drop-shadow-md">
            {CONTENT.home.description}
          </p>
          <div className="flex flex-col sm:flex-row justify-center space-y-6 sm:space-y-0 sm:space-x-8">
            <a 
              href="#contact" 
              onClick={(e) => handleScroll(e, 'contact')}
              className="bg-primary text-white px-14 py-6 font-bold uppercase tracking-[0.25em] text-[11px] rounded-full hover:shadow-2xl hover:-translate-y-1 transition-all duration-500 shadow-lg shadow-black/20"
            >
              {CONTENT.home.buttons.primary}
            </a>
            <a 
              href="#werkwijze" 
              onClick={(e) => handleScroll(e, 'werkwijze')}
              className="bg-white/10 backdrop-blur-md border border-white/30 text-white px-14 py-6 font-bold uppercase tracking-[0.25em] text-[11px] rounded-full hover:bg-white hover:text-primary transition-all duration-300 flex items-center justify-center"
            >
              {CONTENT.home.buttons.secondary}
            </a>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 hidden lg:flex flex-col items-center">
        <div className="w-[1px] h-20 bg-gradient-to-b from-white to-transparent opacity-50"></div>
      </div>
    </div>
  );
};

export default Home;
